import React from "react";

const IconArrowRightUp = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={18}
      viewBox="0 0 19 18"
      fill="none"
      {...props}
    >
      <path
        d="M18.6302 0.98199V13.7399C18.6302 14.0002 18.5268 14.2498 18.3428 14.4339C18.1587 14.6179 17.9091 14.7213 17.6488 14.7213C17.3886 14.7213 17.1389 14.6179 16.9549 14.4339C16.7709 14.2498 16.6675 14.0002 16.6675 13.7399V3.35079L2.64109 17.3784C2.45695 17.5625 2.20719 17.666 1.94677 17.666C1.68635 17.666 1.43659 17.5625 1.25244 17.3784C1.0683 17.1942 0.964844 16.9445 0.964844 16.6841C0.964844 16.4236 1.0683 16.1739 1.25244 15.9897L15.28 1.96337H4.89091C4.63063 1.96337 4.38101 1.85997 4.19697 1.67593C4.01292 1.49188 3.90953 1.24227 3.90953 0.98199C3.90953 0.721712 4.01292 0.472094 4.19697 0.28805C4.38101 0.104006 4.63063 0.000610352 4.89091 0.000610352H17.6488C17.9091 0.000610352 18.1587 0.104006 18.3428 0.28805C18.5268 0.472094 18.6302 0.721712 18.6302 0.98199Z"
        // fill="#18242D"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconArrowRightUp;
